import {UserMetaDto} from '@sharedrest/identity.restservice';

export class User {
  user_uuid: string;
  user_name: string;
  full_name: string;
  lang_code: string;
  rights: string[];
  entities: string[];
  activities: string[];
  authorities: string[];
  metas: UserMetaDto[];
  gdpr_accept: boolean;
  terms_acceptance: string;
  personal_data_acceptance: string;
  email: string;
  licenses: UserLicense[];
}

export class UserLicense {
  product: string;
  endDate: string;
  valid: boolean;
  modules: string[];
}
